angular.module('TetherApp').factory('giftWithPurchasePrizingService', [
    '$http',
    function ($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let index = function (id) {
            let uri = '/api/v1/experience/gift-with-purchase/' + id + '/prize-pool';
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let store = function (id, data) {
            return $http.post('/api/v1/experience/gift-with-purchase/' + id + '/prize-pool', data, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let update = function (id, poolId, data) {
            return $http.put('/api/v1/experience/gift-with-purchase/' + id + '/prize-pool/' + poolId, data, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let indexType = function (id, poolId) {
            return $http.get(
                '/api/v1/experience/gift-with-purchase/' + id + '/prize-pool/' + poolId + '/prize-type',
                {cache: false, headers: { 'Cache-Control': 'no-cache' }}
            ).then(function (response) {
                return response.data;
            });
        };

        let storeType = function (id, poolId, data) {
            return $http.post(
                '/api/v1/experience/gift-with-purchase/' + id + '/prize-pool/' + poolId + '/prize-type',
                data,
                {cache: false, headers: { 'Cache-Control': 'no-cache' }}
            ).then(function (response) {
                return response.data;
            });
        };

        return {
            index: index,
            store: store,
            update: update,
            indexType: indexType,
            storeType: storeType
        };

    }
]);
